import type { SelectOption } from "@/components/form-builder"

export const MARITAL_STATUS_OPTIONS: SelectOption[] = [
  { value: "1", label: "Solteiro(a)" },
  { value: "2", label: "Casado(a)" },
  { value: "3", label: "Divorciado(a)" },
  { value: "4", label: "Viúvo(a)" },
  { value: "5", label: "União Estável" },
]

export const PRONOUNS_OPTIONS: SelectOption[] = [
  { value: "1", label: "Ele/Dele" },
  { value: "2", label: "Ela/Dela" },
  { value: "3", label: "Elu/Delu" },
  { value: "4", label: "Outro" },
]
